import { render, staticRenderFns } from "./PointListItem.vue?vue&type=template&id=12e07a50&"
import script from "./PointListItem.vue?vue&type=script&lang=js&"
export * from "./PointListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports